<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table :headers="headers"
                        :items="archivedTasks"
                        :options.sync="options"
                        :footer-props="footer_props"
                        :server-items-length="archivedCount"
                        disable-sort
                        item-key="name"
                        class="elevation-1 task-archived">
            <template v-slot:item.action="{ item }">
              <v-icon color="accent"
                      class="mr-2"
                      @click="restoreDialogForTask(item)">
                restore
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <template>
        <v-row justify="center">
          <v-dialog v-model="restoreConfirmDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline pt-1 pr-1">
                Confirm Restore
                <v-spacer></v-spacer>
                <v-btn icon @click="restoreConfirmDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text> Are you sure you want restore this task?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn outlined color="accent" @click="restoreMethod(workOrderTask)">Restore</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ArchiveTaskList',
  created () {
    this.loadArchived()
  },
  watch: {
    options: {
      handler () {
        this.loadArchived(false)
      },
      deep: true
    },
   searchObject: {
      handler () {       
        this.loadArchived(true)   
      },
      deep: true
    },
  },
  data () {
    return {
      deleteConfirmDialog: false,
      restoreConfirmDialog: false,
      user: null,
      // pagination
      options: { itemsPerPage: 10, page: 1 },
      footer_props: {
        'items-per-page-options': [5, 10, 15, 20],
        'showFirstLastPage': true,
        'firstIcon': 'mdi-page-first',
        'lastIcon': 'mdi-page-last'
      }
    }
  },
  methods: {
    ...mapActions({
      loadArchivedTasks: 'workOrderTask/loadArchivedTasks',
      restoreTask: 'workOrderTask/restoreTask',
      loadWorkOrderTasks: 'workOrderTask/getTasks'
    }),

    restoreDialogForTask (item) {
      this.restoreConfirmDialog = true
      this.workOrderTask = item
    },
    async restoreMethod (workOrderTask) {
      this.restoreConfirmDialog = await this.restoreTask(workOrderTask.id)
      this.refresh()
    },
    refresh () {
      this.loadArchived()
      this.loadWorkOrderTasks(this.searchObject)
    },
    loadArchived (reset) {

      const { page, itemsPerPage } = this.options
      let search = {
        searchISD: this.searchObject.searchISD,
        searchRegion: this.searchObject.searchRegion,
        searchStatus: this.searchObject.searchStatus,
        searchGeneral: this.searchObject.searchGeneral,
        searchCrew: this.searchObject.searchCrew,
        searchFlagged: this.searchObject.searchFlagged,
        searchLabel: this.searchObject.searchLabel,
        searchCheckedType: this.searchObject.searchCheckedType,
        searchWorkOrders: this.searchObject.searchWorkOrders,
        searchStartDate: this.searchObject.searchStartDate,
        searchCPA: this.searchObject.searchCPA,
        searchFCMP: this.searchObject.searchFCMP,
        searchDCMP: this.searchObject.searchDCMP,
        searchReturn: { pageIndex: page, pageSize: itemsPerPage }
      } 

      this.loadArchivedTasks(search)
    }
  },
  computed: {
    ...mapGetters({
      archivedTasks: 'workOrderTask/archivedTasks',
      archivedCount: 'workOrderTask/archivedTotal',
      headers: 'workOrderTask/headers',
      searchObject: 'workOrderTask/searchObject'
    })
  }
}
</script>

<style>
  .task-archived .text-start {
    max-width: 150px;
  }
</style>
